module.exports = __webpack_public_path__ + "static/media/cbc37a5c-665d-4059-8a9c-43b5261d3a75.9ed86b27.png";